import { PublicClientApplication } from "@azure/msal-browser";
import {RedirectRequest} from "@azure/msal-browser";
import { MsalConfig } from "../AppConfig";

// non MS auth: 
//- https://stackoverflow.com/questions/67934505/using-msal-with-non-microsoft-identity-providers
//- https://learn.microsoft.com/en-us/azure/active-directory-b2c/identity-provider-generic-openid-connect?pivots=b2c-user-flow

// const msalConfig = {
//     auth: {
//         clientId: process.env.REACT_APP_ClientId ?? '',
//         authority: process.env.REACT_APP_Authority,
//         redirectUri: process.env.REACT_APP_RedirectUri,
//         navigateToLoginRequestUrl: false
//     },
//     cache: {
//         cacheLocation: "localStorage", // Da deluje "Single sign-out", mora biti določena vrednost "localStorage".
//         storeAuthStateInCookie: false
//     },
//     system: {
//         allowRedirectInIframe: true // Da deluje "Single sign-out".
//     }
// };

/*
const LoginRequest = {
    scopes: ["User.Read"]
};

const AccessTokenRequest = {
    scopes: [process.env.REACT_APP_Scopes ?? '']
};
*/

const scopes = [
    process.env.REACT_APP_Scopes ?? ''
]

const loginRequest: RedirectRequest = {
    scopes: scopes
}

const msalInstance = new PublicClientApplication(MsalConfig);

export {msalInstance, loginRequest, scopes}